import {
  Webhook,
  WebhookPostRequest,
  WebhookPutRequest,
} from "callable-data-objects";
import { useAccount } from "Hooks/Endpoints";
import { APIAccountWebhookContext } from "Providers/APIContexts";
import React, { useEffect, useState } from "react";

const APIAccountWebhookProvider = ({ children }: any) => {
  const { account, select: selectAccount, webhookService } = useAccount();
  const [hooks, setHooks] = useState<Webhook[]>([]);
  const [hook, setHook] = useState<Webhook>();
  const [createHook, setCreateHook] =
    useState<WebhookPostRequest | undefined>();

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  function unload() {
    setTimeout(() => {
      setLoading(false);
    }, 250);
  }

  async function list() {
    setLoading(true);
    const resp = await webhookService?.list();
    if (resp) setHooks(resp);
    unload();
  }

  async function select(id: string) {
    setLoading(true);
    const resp = await webhookService?.get(id);
    if (resp) setHook(resp);
    unload();
  }

  function unselect() {
    setHook(undefined);
  }

  async function update(payload: WebhookPutRequest) {
    if (hook && account) {
      setLoading(true);
      await webhookService?.put(hook.id, payload);
      await list();
      await selectAccount(account.id);
      unselect();
      unload();
    }
  }

  async function save(payload: WebhookPostRequest) {
    if (account) {
      const resp = await webhookService?.post("", payload);
      if (resp) {
        uncreate();
        list();
        selectAccount(account.id);
        unload();
      }
    }
  }

  async function remove() {
    if (account && hook) {
      setLoading(true);
      await webhookService?.delete(hook.id);
      selectAccount(account.id);
      list();
      unselect();
      unload();
    }
  }

  function create() {
    setCreateHook({
      url: "",
      app: "ivr.generic",
      authType: "DISABLED",
      apiKeyName: "",
      apiKeyValue: "",
      apiSecretName: "",
      apiSecretValue: "",
      meta: {},
    });
  }

  function uncreate() {
    setCreateHook(undefined);
  }

  return (
    <APIAccountWebhookContext.Provider
      value={{
        loading,
        account,
        hooks,
        hook,
        createHook,
        create,
        uncreate,
        select,
        unselect,
        update,
        save,
        remove,
      }}
    >
      {children}
    </APIAccountWebhookContext.Provider>
  );
};

export default APIAccountWebhookProvider;
